import React from "react";
import {
  AppBox,
  AppBoxChild,
  AppBoxChildHeadline,
  AppBoxChildDetails,
  AppBoxImage,
} from "../styled-components/general";
import { useNavigate } from "react-router-dom";
import { AppPageDetails } from "../config/info";
// import edc15Image from "../../src/assets/images/EDC.png"
// import med9Image from "../../src/assets/images/EDC.png"
import edc15Image from "../../src/assets/images/EDc15.jpeg";
import med9Image from "../../src/assets/images/MED.jpeg";

function AppList() {
  let navigate = useNavigate();
  const setProductPage = (link) => {
    navigate(link);
  };

  return (
    <AppBox>
      <AppBoxChild onClick={() => setProductPage("/edc15")}>
        <AppBoxImage
          src={edc15Image}
          alt="EDC15"
          style={{ objectFit: "contain", width: "100%", height: "220px" }}
         
        />
        <AppBoxChildHeadline>EDC15</AppBoxChildHeadline>
        <AppBoxChildDetails>{AppPageDetails("edc15")}</AppBoxChildDetails>
        {/* <AppBoxButton>Try Now</AppBoxButton> */}
      </AppBoxChild>
      <AppBoxChild onClick={() => setProductPage("/med9")}>
        <AppBoxImage
          src={med9Image}
          alt="MED9"
          style={{ objectFit: "contain", width: "100%", height: "220px" }}
          
        />
        <AppBoxChildHeadline>MED9</AppBoxChildHeadline>
        <AppBoxChildDetails>{AppPageDetails("med9")}</AppBoxChildDetails>
        {/* <AppBoxButton>Try Now</AppBoxButton> */}
      </AppBoxChild>
    </AppBox>
  );
}

export default AppList;
